import { apiServiceWrapper } from '../../../../Middleware/API/apiRequest';
import { getTokensFromStorage } from '../../../../Utils/Auth/AuthToken';
import { INTEGRATION_SYSTEMS } from '../../../../constants/apiRoutes';
import {
  getGraphqlCacheResponse,
  setGraphqlCacheResponse,
} from '../../../../Utils/Storage/IndexDB/indexDbWrappers';
/**
 * list Integration Systems.
 * @returns {Promise} - A promise that resolves with the list of IntegrationSystems or rejects with an error.
 * @param props
 */
export const listIntegrationSystem = async ({
  limit,
  offset,
  filter,
  sort,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const data = {
    Filters: filter,
    pageNumber: offset === 0 ? 1 : offset,
    pageSize: limit,
    sort,
  };
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_SYSTEMS}/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  if (response?.isError) {
    if (isServiceWorker) {
      let cacheResponse = await getGraphqlCacheResponse(
        headers,
        isServiceWorker,
      );
      return cacheResponse;
    }
    return response;
  }
  if (isServiceWorker) {
    await setGraphqlCacheResponse(headers, response, isServiceWorker);
  }
  return {
    IntegrationSystems: response.Payload,
    TotalCount: response?.TotalRecordCount,
  };
};

/**
 * Create Integration System.
 * @returns {Promise} - A promise that resolves with the creation of Integration System or rejects with an error.
 * @param data
 */
export const createIntegrationSystem = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_SYSTEMS}`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Update Integration System.
 * @returns {Promise} - A promise that resolves with the update of Integration System or rejects with an error.
 * @param data
 */
export const updateIntegrationSystem = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_SYSTEMS}/${data?.IntegrationId}`,
    method: 'PUT',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * delete Integration System.
 * @returns {Promise} - A promise that resolves with the update of Integration System or rejects with an error.
 * @param data
 */
export const deleteIntegrationSystem = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_SYSTEMS}?integrationId=${data?.IntegrationId}&sysType=${data?.SysType}&tenantId=${data?.TenantId}`,
    method: 'DELETE',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * get Integration System.
 * @returns {Promise} - A promise that resolves with the IntegrationSystem or rejects with an error.
 * @param data
 */
export const getIntegrationSystem = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `${INTEGRATION_SYSTEMS}?integrationId=${data?.IntegrationId}&sysType=${data?.SysType}&tenantId=${data?.TenantId}`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};

/**
 * Filter Tags by tenant + name.
 * @returns {Promise} - A promise that resolves with the filter response.
 */
export const filterIntegrationTags = async ({
  tenantId,
  searchText,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const data = {
    pageNumber: 0,
    pageSize: 0,
    sortField: [],
    Filters: [
      {
        ColumnName: 'TenantId',
        Op: 'eq',
        ColumnValue: tenantId,
      },
      {
        ColumnName: 'SourceSystem',
        Op: 'eq',
        ColumnValue: 'SmartApps',
      },
      {
        ColumnName: 'Name',
        Op: 'contains',
        ColumnValue: searchText,
      },
    ],
    Attributes: [],
  };

  const response = await apiServiceWrapper({
    url: `/api/Applications/Tags/Filter`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });

  return response;
};

/**
 * Save/Update Tag Assignments for Integration entity.
 * @returns {Promise} - A promise that resolves with the save response.
 */
export const saveIntegrationTagAssignments = async ({
  data,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `/api/Applications/Tags/Assignments`,
    method: 'POST',
    moduleName,
    isServiceWorker,
    listController,
    body: data,
    accessToken,
  });
  return response;
};

/**
 * Get Tag Assignments for Integration entity.
 * @returns {Promise} - A promise that resolves with the get response.
 */
export const getIntegrationTagAssignments = async ({
  tenantId,
  entityId,
  moduleName,
  isServiceWorker,
  listController,
}) => {
  const { accessToken } = getTokensFromStorage();
  const response = await apiServiceWrapper({
    url: `/api/Applications/Tags/Assignments?entityType=INTEGRATION&entityId=${encodeURIComponent(entityId)}&tenantId=${encodeURIComponent(tenantId)}&sourceSystem=SmartApps`,
    method: 'GET',
    moduleName,
    isServiceWorker,
    listController,
    accessToken,
  });
  return response;
};
